// import * as React from 'react'
import sortBy from 'lodash.orderby'
import { match } from 'react-router'
import { useWorkflow } from '../../../../context/reports/workflow'
import { getWorkflowGridData, getWorkflowBars } from '../utils'
import { SingleBar } from '../types'
import { GridProps } from '../components/WorkflowDatagrid'
import * as routes from '../../../../utils/routes'

export interface WorkflowChartData {
  bars: SingleBar[]
  gridData: GridProps
}

interface MatchParams {
  siteId: string
  teamId: string
}

export const useChart = (match: match<MatchParams>): WorkflowChartData => {
  const [state] = useWorkflow()
  const current = state.metrics[state.metrics.currentMetricsType]
  const type = state.byType // bySite or byResponsible (team)

  const filterBy = match.path === routes.REPORTS.WorkflowSite
    ? [match.params.siteId]
    : match.path === routes.REPORTS.WorkflowTeam
      ? [match.params.teamId]
      : []

  // @TODO: Try to memorise.
  const bars: SingleBar[] = sortBy(getWorkflowBars(current, type, filterBy), o => o.value, state.sortingDirection)
  const gridData = getWorkflowGridData(current, type, filterBy)

  return {
    bars,
    gridData
  }
}
